import React from 'react';
import Chat from './components/Chat';

export default function Inbox() {
    return (
        <div>
            <Chat />
        </div>
    )
}